import firebase from "firebase/app";
import Vue from 'vue';
import "firebase/firestore";
import {saveWagonToFB} from "./v_utils";
import moment from "moment";
import i18n from '../i18n';

function updateGroupInWagons(wagons, group, tmr)
{
    let groupInWagonsCount = 0;
    wagons.forEach(function(w) {
        if (w.groups && w.tmr.code == tmr.code) {
            w.groups.forEach(function(g) {
                if (g.code == group.code)
                        groupInWagonsCount++;
            });
        }
    });
    let dailyPercent = groupInWagonsCount == 0 ? 100 : Math.round(100/groupInWagonsCount*100)/100;

    wagons.forEach(function(w) {
        if (w.groups && w.tmr.code == tmr.code) {
            w.groups.forEach(function(g) {
                if (g.code == group.code) {
                    var tmrPercent = 100;
                    if (w.tmr.code == group.defaultTMR.code)
                        tmrPercent = group.defaultTMR.dailyPercent;
                    else if (w.tmr.code == group.secondTMR.code)
                        tmrPercent = group.secondTMR.dailyPercent;
                    g.dailyPercent = dailyPercent;
                    g.qty = Math.round(group.cowCount * tmr.doseweight * (group.hungerPercent/100) * (dailyPercent/100) * (tmrPercent/100))
                    //update daily qty..
                    g.dailyQty = group.weeklyDelivery.map((v) => v*g.qty);
                }
            });
        }
    });
    return wagons;
}
export default {
    unsubscribeAllSnaps(state) {
        state.FeedUnsubscribe();
        state.GroupUnsubscribe();
        state.TmrsUnsubscribe();
        state.WagonUnsubscribe();
        state.DashUnsubscribe();
        state.EquipUnsubscribe();
    },
    setDrawerState(state, payload) {
        state.drawer = payload;
    },
    setUser (state, payload) {
        state.user = payload
        if (state.user && state.user.name && state.user.uid) {
            firebase.firestore().collection("/Users").doc(state.user.uid).get()
            .then(doc => {
                if (doc.exists) {
                    state.Profile = doc.data();
                    i18n.locale = state.languages[state.Profile.language];
                } else  {
                    state.Profile= {};
                  //console.log(`User '${state.user.name}' does not have a profile`);
                }
            })
            .catch( () => {  //err
                state.Profile= {};
              //console.log(`Error getting profile for user '${state.user.name}': ${err}`);
            })
        } else {
            state.Profile= {};
        }
    },
    assumeUid(state, payload) {
        state.user.uid = payload;
    },
    setProfile (state, payload) {
        if (state.user && payload ) {
            firebase.firestore().collection("/Users").doc(state.user.uid).set(payload);
            state.Profile = payload;
        }
    },
    updateProfile(state, payload) {
        if (state.user && payload) {
            firebase.firestore().collection("/Users").doc(state.user.uid).update(payload);
            state.Profile = {...state.Profile, ...payload};
        }
    },
    //=============== Feeds ====================
    setFeeds(state, payload) {
        state.Feeds = payload;
    },
    delFeed(state, id) {
        state.Feeds = state.Feeds.filter(function(f) {
            return f.id != id;
        })
    },
    updateFeed(state, payload) {
        var index = state.Feeds.findIndex(x=> x.id == payload.id);
        if (index === -1)
            state.Feeds.push(payload);
        else
            state.Feeds[index] = payload;
    },
    FeedUnsubscribeFunc(state, payload) {
        state.FeedUnsubscribe = payload;
    },
    FeedUnsubscribeNow(state) {
        state.FeedUnsubscribe();
    },

    //=============== TMRs ====================
    setTMRs(state, payload) {
        state.TMRs = payload;
    },
    delTMR(state, id) {
        state.TMRs = state.TMRs.filter(function(t) {
            return t.id != id;
        })
    },
    updateTMR(state, payload) {
        var index = state.TMRs.findIndex(x=> x.id == payload.id);
        if (index === -1)
            state.TMRs.push(payload);
        else
            state.TMRs[index] = payload;
    },
    TmrsUnsubscribeFunc(state, payload) {
        state.TmrsUnsubscribe = payload;
    },
    TMRUnsubscribeNow(state){
        state.TmrsUnsubscribe();
    },


    //=============== Groups ====================
    setGroups(state, payload) {
        state.Groups = payload;
    },
    delGroup(state, id) {
        state.Groups = state.Groups.filter(function(g) {
            return g.id != id;
        })
    },
    updateGroup(state, payload) {
        var index = state.Groups.findIndex(x=> x.id == payload.id);
        if (index === -1)
            state.Groups.push(payload);
        else
            state.Groups[index] = payload;
    },
    groupUnsubscribeFunc( state, payload) {
        state.GroupUnsubscribe = payload;
    },
    GroupUnsubscribeNow(state) {
        state.GroupUnsubscribe();
    },

    //=============== Wagons ====================
    setWagons(state, payload) {
        state.Wagons = payload;
    },
    delWagon(state, id) {
        let wagonIndex = state.Wagons.findIndex(x=> x.id == id);
        let wagonGroups = [];
        let tmr = {};
        if (wagonIndex>=0) {
            wagonGroups = Object.assign([], state.Wagons[wagonIndex].groups);
            tmr = state.TMRs.find((t) => t.Id == state.Wagons[wagonIndex].tmr.documentID);
        }
        //remove from array..
        state.Wagons = state.Wagons.filter(function(w) {
            return w.id != id;
        })
        //update daily % for all groups in this removed wagons:
        wagonGroups.forEach(function(grp) {
            let group = state.Groups.find((x) => x.Id == grp.documentID)
            state.Wagons = updateGroupInWagons(state.Wagons, group, tmr)
        });
        //save ALL wagons
        state.Wagons.forEach((wgn) => { saveWagonToFB(state, wgn) });
    },
    updateWagon(state, data) {

        var index = state.Wagons.findIndex(x=> x.id == data.wgn.id);
        if (index === -1)
            state.Wagons.push(data.wgn);
        else
            state.Wagons[index] = data.wgn;

        if (data.group && data.tmr)
            state.Wagons = updateGroupInWagons(state.Wagons, data.group, data.tmr);

        //save ALL wagons
        state.Wagons.forEach((wgn) => { saveWagonToFB(state, wgn) });
    },
    wagonUnsubscribeFunc(state, payload) {
        state.WagonUnsubscribe = payload;
    },
    WagonUnsubscribeNow(state) {
        state.WagonUnsubscribe();
    },
    setSelectedDays(state, payload) {
        state.selectedDays = payload;
    },
    //=================== Dashboard Data ==================
    setDashData(state, payload) {
        //console.log(payload);
        while(state.labels.length > 0) state.labels.pop();      //empty the array reactively
        state.yesterdayMake = [];
        state.yesterdayDeliver = [];
        state.todayMake = [];
        state.todayDeliver = [];
        payload.forEach(x => {
            let indx = state.labels.length;
            Vue.set(state.labels, indx, x.name)
            if (moment(x.endTime).isBefore(moment().startOf("day"))) {
                state.yesterdayMake.push(x.made);
                state.yesterdayDeliver.push(x.delivery);
            } else {
                state.todayMake.push(x.made);
                state.todayDeliver.push(x.delivery);
            }
        });
    },
    dashUnsubscribeFunc(state, payload) {
        state.DashUnsubscribe = payload;
    },
    DashUnsubscribeNow(state) {
        state.DashUnsubscribe();
    },
    //====================== Equipment data =============
    setEquipments(state, payload) {
        state.Equipments = payload;
    },
    equipUnsubscribeFunc(state, payload) {
        state.EquipUnsubscribe = payload;
    },
    setLanguage(_locale) {
        i18n.locale = _locale;
    },

    //====================== Inv Count data =============
    setInvCount(state, payload) {
        state.invCount = payload;
    },

    //====================== Inv Count data =============
    updateRecipe(state, payload) {
        var index = state.Recipes.findIndex(x=> x.id == payload.id);
        if (index === -1)
        state.Recipes.push(payload);
        else
        state.Recipes[index] = payload;
    },

    //====================== Recipe data =============
    setRecipes(state, payload) {
        state.Recipes = payload;
    },
    RecipeUnsubscribeFunc(state, payload) {
        state.RecipeUnsubscribe = payload;
    },
    delRecipe(state, id) {
        state.Recipes = state.Recipes.filter((r) => {r.id != id});
    },
}